import React from 'react';
import { useDispatch } from 'react-redux';
import { openLoginModal } from 'src/store/layout/slice';
import { UnAuthorizedMenu } from './UnAuthorizedMenu';
import { useHistory } from 'react-router';
import { APP_ROUTES } from '../../../../../routing/AppRoutes';

export const UnAuthorizedMenuContainer: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onJournalistRegister = () =>{
    localStorage.setItem("userType", "Journalist")
    history.push(APP_ROUTES.REG_AS_JOURNALIST)
  }

  const onExpertRegister = () =>{
    localStorage.setItem("userType", "Expert")
    history.push(APP_ROUTES.REG_AS_EXPERT1)
  }

  return (
    <UnAuthorizedMenu
      onLoginClick={() => dispatch(openLoginModal("Journalist"))}
      onJournalistRegisterClick={onJournalistRegister}
      onExpertRegisterClick={onExpertRegister}
    />
  );
};
